import theme from 'foundations/theme';
import { ExternalUrls } from 'utils/redirections';

//plans
export const FREE = 'Free';
export const BUSINESS = 'Social Webinar';
export const BUSINESS_OLD = 'Business';
export const ENTERPRISE = 'Pro';
export const ENTERPRISE_OLD = 'Conference';
export const BUSINESS_PRO = 'Social Webinar Pro';
export const BUSINESS_PRO_OLD = 'Business Pro';
export const CONFERENCE_STARTER = 'Conference Starter';
export const CONFERENCE_PREMIUM = 'Conference Premium';
export const CONFERENCE_PRO = 'Conference Pro';
export const STANDARD = 'Standard';

//business plan subtypes
export const BUSINESS_MONTHLY = 'Business_Monthly';
export const BUSINESS_YEARLY = 'Business_Yearly';
export const STANDARD_YEARLY = 'Standard_Yearly';
export const ONE_TIME_30_DAYS_PLAN = 'social-webinar-30-days-pe-one-time';
export const ONE_TIME_60_DAYS_PLAN = 'social-webinar-60-days-pe-one-time';

//conference plan subtypes
export const CONFERENCE_STARTER_MONTHLY = 'conference-starter-tiered';
export const CONFERENCE_PRO_MONTHLY = 'conference-pro';

//misc
export const BILLING_HOME_SCREEN = 'BILLING_HOME_SCREEN';
export const PLAN_UPGRADE_SCREEN = 'PLAN_UPGRADE_SCREEN';
export const SOCIAL_WEBINAR_TAB = 'SOCIAL_WEBINAR_TAB';
export const CONFERENCE_TAB = 'CONFERENCE_TAB';
export const COMBINED_TAB = 'COMBINED_TAB';
export const EVENTS_TAB = 'EVENTS_TAB';
export const BILLED_MONTHLY_TAB = 'Bill Monthly';
export const BILLED_ANNUALLY_TAB = 'Bill Annually– Save 10%';
export const BILLING_SECTION = 'BILLING_SECTION';
export const VALIDITY_SECTION = 'VALIDITY_SECTION';
export const PAY_MONTHLY = 'Pay monthly';
export const PAY_ANNUALLY = 'Pay annually';
export const VALIDITY_30_DAYS = '30 days validity';
export const VALIDITY_60_DAYS = '60 days validity';

export const planMappingToSubTypes = {
    [FREE]: 'Starter',
    [BUSINESS]: 'Growth',
    [ENTERPRISE]: 'Enterprise',
    [BUSINESS_PRO]: 'Business Pro',
    [BUSINESS_OLD]: 'Growth',
    [ENTERPRISE_OLD]: 'Enterprise',
    [CONFERENCE_STARTER]: 'Conference Starter',
    [CONFERENCE_PREMIUM]: 'Enterprise',
    [CONFERENCE_PRO]: 'Conference Pro',
    [STANDARD]: 'Standard',
};

export const plansDetailsMapping = {
    [planMappingToSubTypes[FREE]]: {
        displayName: FREE,
        summary:
            'For small engaging events, training sessions, and community meet-ups',
        features: [
            { title: 'Get 1 organizer license' },
            { title: 'Host unlimited events' },
            { title: 'Run sessions up to 90 mins' },
            { title: 'Download SD recordings' },
            { title: 'Play pre-recorded videos' },
            { title: 'Plan speed networking' },
            { title: 'Sell and manage tickets' },
            { title: 'Stream on social media' },
            { title: 'Track real-time event analytics' },
        ],
        pricing: '0',
        paymentCycle: null,
        extraFeature: 'Up to 100 registrations/event',
        sliderText: 'Registrations per event',
        callToAction: 'Your Current Plan',
        buttonId: 'current-plan-button',
        listSubHeading: null,
        listSuffixText: null,
        priceOnRequest: false,
        redirectToContactSalesTypeform: false,
        planBtnDisabled: true,
        isMostPopularPlan: false,
        hasStartingPrice: false,
        additionalText: '',
        planBtnBackground: 'transparent',
        planBtnBorder: 'transparent',
        planBtnColor: 'ambience.6',
        planTitleColor: 'accentContentDisable',
        planSubheadingColor: 'accentContentDisable',
        planPriceColor: 'accentContentTertiary',
        eventType: planMappingToSubTypes[FREE],
        additionalPricingInfo: '',
        registrationsStripText: 'Upto 100 registrations/event',
        registrationsDropdown: false,
    },
    [planMappingToSubTypes[BUSINESS]]: {
        displayName: BUSINESS,
        summary:
            'Customizable, live and on-demand webinars, that connect with your tools',
        features: [
            {
                title: 'up to 1000 Registrations/event',
                hideLineItem: true,
            },
            {
                title: '10 Organizers',
                hideLineItem: true,
            },
            {
                title: 'Unlimited session duration',
            },
            {
                title: 'HD Recording',
            },
            {
                title: 'Custom registration forms',
            },
            {
                title: 'Event branding',
            },
            {
                title: 'Sponsor showcase',
            },
            {
                title: 'Advanced analytics',
            },
            {
                title: 'Zapier, HubSpot, MailChimp, Eventbrite integrations',
            },
            {
                title: 'Public APIs',
            },
            {
                title: 'Priority support',
            },
        ],
        pricing: '$99',
        paymentCycle: '/mo',
        extraFeature: '100 registrations/event',
        quoteSubText: {
            [BUSINESS_MONTHLY]: '',
            [BUSINESS_YEARLY]: 'billed annually',
        },
        callToAction: 'Upgrade',
        buttonId: 'buy-plan-button',
        listSubHeading: `Everything in ${FREE}, plus...`,
        listSuffixText: null,
        priceOnRequest: false,
        redirectToContactSalesTypeform: false,
        planBtnDisabled: false,
        isMostPopularPlan: true,
        hasStartingPrice: true,
        additionalText: 'Everything in "FREE" plus...',
        planBtnBackground: theme.colors.lighting[7],
        planBtnBorder: 'transparent',
        planBtnColor: 'ambience.24',
        eventType: planMappingToSubTypes[BUSINESS],
        additionalPricingInfo: '',
    },
    [planMappingToSubTypes[ENTERPRISE]]: {
        displayName: 'Pro',
        summary:
            'For large virtual & hybrid conferences, conventions, and tradeshows.',
        features: [
            { title: 'Host multi-track events' },
            { title: 'Get session replays' },
            { title: 'Customize Receptions' },
            { title: 'Brand your event URL' },
            { title: 'Get a lounge space for fluid conversations' },
            { title: 'Use event gamification tools' },
            { title: 'Expand networking tables up to 50 people' },
            { title: 'Access via single sign-on (SSO)' },
            {
                title: 'Scheduled group and 1:1 meetings',
            },
        ],
        pricing: '7,500',
        paymentCycle: '',
        extraFeature: 'Upto 100,000 registrations/event',
        quoteSubText: {
            [BUSINESS_MONTHLY]: '',
            [BUSINESS_YEARLY]: 'billed annually',
        },
        callToAction: 'Talk To Us',
        buttonId: 'contact-sales-button',
        listSubHeading: `Everything in ${FREE}, plus...`,
        listSuffixText: null,
        hasComparePlanButton: false,
        priceOnRequest: false,
        redirectToContactSalesTypeform: true,
        planBtnDisabled: false,
        isMostPopularPlan: true,
        hasStartingPrice: true,
        additionalText: 'Everything in “Standard”, plus...',
        planBtnBackground: theme.colors.accentPrimary[0],
        planBtnBorder: 'transparent',
        planBtnColor: 'ambience.0',
        planTitleColor: 'ambience.0',
        eventType: planMappingToSubTypes[ENTERPRISE],
        additionalPricingInfo: 'billed annually',
        registrationsStripText: 'Scale up to 100,000 registrations',
        registrationsDropdown: false,
    },
    [planMappingToSubTypes[BUSINESS_PRO]]: {
        displayName: BUSINESS_PRO,
        summary:
            'Fully customizable enterprise grade webinar marketing solution',
        features: [
            {
                title: 'up to 100,000 Registrations/event',
                hideLineItem: true,
            },
            {
                title: 'Closed captions',
            },
            {
                title: 'Interprify (Live translation)',
            },
            {
                title: 'SSO',
            },
            {
                title:
                    'Salesforce, Marketo, MS Dynamics & all future integrations',
            },
            {
                title: 'Custom subdomain',
            },
            {
                title: '50 people breakout rooms',
            },
        ],
        pricing: '4000',
        paymentCycle: null,
        extraFeature: '100 registrations/event',
        quoteSubText: {
            [BUSINESS_MONTHLY]: '',
            [BUSINESS_YEARLY]: 'billed annually',
        },
        callToAction: 'Contact Sales',
        buttonId: 'buy-plan-button',
        listSubHeading: null,
        listSuffixText: null,
        priceOnRequest: false,
        redirectToContactSalesTypeform: true,
        planBtnDisabled: false,
        isMostPopularPlan: false,
        hasStartingPrice: true,
        additionalText: 'Everything in "Social Webinar" plus...',
        planBtnBackground: 'transparent',
        planBtnBorder: theme.colors.lighting[7],
        planBtnColor: theme.colors.lighting[7],
        planTitleColor: theme.colors.lighting[7],
        eventType: BUSINESS_PRO,
        additionalPricingInfo: 'billed annually',
        registrationsStripText: '100 registrations/event',
        registrationsDropdown: true,
    },
    [planMappingToSubTypes[CONFERENCE_STARTER]]: {
        displayName: CONFERENCE_STARTER,
        summary: 'Small events, conferences and expos with parallel tracks',
        features: [
            {
                title: 'up to 300 Registrations/month',
                hideLineItem: true,
                textDecoration: 'none',
            },
            {
                title: '3 Organizers',
                textDecoration: 'none',
                hideLineItem: true,
            },
            {
                title: 'Parallel tracks',
                textDecoration: 'none',
            },
            { title: 'Reception ', textDecoration: 'none' },
            {
                title: 'Exhibitor booths',
                textDecoration: 'none',
            },
            {
                title: 'Basic analytics',
                textDecoration: 'none',
            },
            {
                title: 'Hybrid ready',
                textDecoration: 'none',
            },
            {
                title: 'Priority Support',
                textDecoration: 'none',
            },
            {
                title: 'Custom Registration Forms',
                textDecoration: 'none',
            },
            {
                title: 'Event Branding',
                textDecoration: 'line-through',
                hideLineItem: true,
            },
            {
                title: 'Sponsor Showcase',
                textDecoration: 'line-through',
                hideLineItem: true,
            },
            {
                title: 'Session Replay',
                textDecoration: 'line-through',
                hideLineItem: true,
            },
            {
                title: 'Space Customization',
                textDecoration: 'line-through',
                hideLineItem: true,
            },
            {
                title: 'Booth Broadcasts',
                textDecoration: 'line-through',
                hideLineItem: true,
            },
            {
                title: 'OOB Integrations',
                textDecoration: 'line-through',
                hideLineItem: true,
            },
        ],
        pricing: '$99',
        paymentCycle: '/mo',
        extraFeature: 'Up to 300 registrations/event',
        quoteSubText: {
            [BUSINESS_MONTHLY]: '',
            [BUSINESS_YEARLY]: 'billed annually',
        },
        callToAction: 'Upgrade',
        buttonId: 'buy-plan-button',
        listSubHeading: `Everything in ${FREE}, plus...`,
        listSuffixText: null,
        priceOnRequest: false,
        redirectToContactSalesTypeform: true,
        planBtnDisabled: false,
        isMostPopularPlan: false,
        hasStartingPrice: true,
        additionalText: '',
        planBtnBackground: theme.colors.lighting[1],
        planBtnBorder: theme.colors.lighting[1],
        planBtnColor: 'ambience.22',
        eventType: CONFERENCE_STARTER,
        additionalPricingInfo: '',
    },
    [planMappingToSubTypes[CONFERENCE_PRO]]: {
        features: [
            // {
            //     title: '5 team members', Will need to modify later based on team member limits
            //     tooltipText: '',
            // },
            {
                title: 'Parallel tracks',
                tooltipText: '',
            },
            {
                title: 'Custom registration forms',
                tooltipText: '',
            },
            {
                title: 'Custom subdomain',
                tooltipText: '',
            },
            {
                title: 'Session replays',
                tooltipText: '',
            },
            {
                title: 'Space customization',
                tooltipText: '',
            },
            {
                title: 'Booth broadcast',
                tooltipText: '',
            },
            {
                title: 'Scheduled meetings',
                tooltipText: '',
            },
            {
                title: 'Advanced analytics',
                tooltipText: '',
            },
            {
                title: 'All Pro Integrations',
                tooltipText: '',
            },
        ],
    },
    [planMappingToSubTypes[STANDARD]]: {
        displayName: 'Standard',
        summary:
            'Host branded webinars, product launches, and customer workshops.',
        features: [
            {
                title: 'Run endless sessions',
            },
            {
                title: 'Get session replays',
            },
            {
                title: 'Delegate host rights',
            },
            {
                title: 'Download HD recordings',
            },
            {
                title: 'Customize registration form',
            },
            {
                title: 'Stream-in via RTMP',
            },
            {
                title: 'Customize event invitation emails',
            },
            {
                title: 'Use advanced analytics with segmentation',
            },
            {
                title:
                    'Connect with Zapier, HubSpot, Salesforce and 8 other integrations',
            },
        ],
        pricing: ['200', '400', '500'],
        paymentCycle: ' /month',
        extraFeature: '100 registrations/event',
        quoteSubText: {
            [BUSINESS_MONTHLY]: '',
            [BUSINESS_YEARLY]: 'billed annually',
        },
        callToAction: 'Buy Now',
        buttonId: 'buy-plan-button',
        listSubHeading: null,
        listSuffixText: null,
        priceOnRequest: false,
        redirectToContactSalesTypeform: false,
        planBtnDisabled: false,
        isMostPopularPlan: false,
        hasStartingPrice: true,
        additionalText: 'Run endless sessions',
        planBtnBackground: theme.colors.accentPrimary[0],
        planBtnBorder: 'transparent',
        planBtnColor: 'ambience.0',
        planTitleColor: 'ambience.0',
        eventType: BUSINESS_PRO,
        additionalPricingInfo: 'billed annually',
        registrationsStripText: ['100', '300', '500'],
        registrationsDropdown: true,
    },
};

// here year corresponds to price per month billed annually
export const pricePlanMap = {
    0: { month: '99', year: '89' },
    35: { month: '249', year: '224' },
    70: { month: '349', year: '314' },
    100: { month: '599', year: '539' },
};

export const positionValueMap = { 0: 100, 35: 300, 70: 500, 100: 1000 }; //slider val wrt registrants number

export const positionIndexMap = { 0: 0, 1: 35, 2: 70, 3: 100 };
export const URLS = {
    support: 'https://www.airmeet.com/e/b6645470-f81d-11ea-bdd0-e9fe5fe214a9',
    upgradeToEnterprise: 'https://www.airmeet.com/hub/talk-to-us/',
    getInTouch: 'https://airmeet.typeform.com/to/ITGNxu06',
    requestPlanChange: 'https://airmeet.typeform.com/to/KFn4yeKv',
    airmeetPricingHub: ExternalUrls.PRICING_PAGE,
    contactSales: 'https://www.airmeet.com/hub/talk-to-us/',
};

export const CHARGEBEE_CONFIG = {
    site: process.env.REACT_APP_CHARGEBEE_SCRIPT_VERSION,
    url: 'https://js.chargebee.com/v2/chargebee.js',
    publishableKey: process.env.REACT_APP_CHARGEBEE_PUBLISHABLE_KEY,
};

export const eventActionLogsMapping = {
    Growth: 'buyNowButtonClicked',
    Enterprise: 'proTalkToUsButtonClicked',
    pageView: 'billingPageView',
    toggleEvent: 'annualMonthlyToggle',
    oneTimeBilling: 'oneTimeBilling',
    subscriptionBilling: 'subscriptionBilling',
    oneTimeValidity: 'oneTimeValidity',
    subscriptionValidity: 'subscriptionValidity',
    getInTouch: 'getInTouch',
    contactSupport: 'contactSupport',
    requestPlanChange: 'requestPlanChange',
    featureListClicked: 'featureListClicked',
    faqClicked: 'faqClicked',
    hoverFeatureItems: 'hoverFeatureItems',
    upgradeMyAccountClicked: 'upgradeMyAccountClicked',
    applyCouponClicked: 'applyCouponClicked',
    planQuantityChanged: 'planQuantityChanged',
    addingBillingDetails: 'addingBillingDetails',
    addingCardDetails: 'addingCardDetails',
    viewCustomerPortal: 'viewCustomerPortal',
    subscriptionCreationSuccess: 'subscriptionCreationSuccess',
    subscriptionCreationFailure: 'subscriptionCreationFailure',
    lockinConsentCaptured: 'lockinConsentCaptured',
    toggleBillingTabs: 'billingTabsToggled',
    disabledUpgradeMyAccountClicked: 'disabledUpgradeMyAccountClicked',
    [CONFERENCE_PREMIUM]: 'conferencePremiumContactSalesButtonClicked',
    [CONFERENCE_STARTER]: 'conferenceStarterBuyNowButtonClicked',
    [BUSINESS_PRO]: 'swproContactSalesClicked',
    [STANDARD]: 'standardBuyNowButtonClicked',
    comparePlans: 'comparePlansButtonClicked',
    oneTimeEventOption: 'oneTimeEventOptionClicked',
};

export const PERIOD_UNIT_WITH_SUFFIXES = {
    day: 'daily',
    month: 'monthly',
    year: 'yearly',
    once: 'once',
};

export const MANAGE_ACCOUNT_PLANS = [
    {
        title: 'Account information',
        img_path: '/images/community/portal-info.svg',
    },
    {
        title: 'Payment methods',
        img_path: '/images/community/portal-payment.svg',
    },
    {
        title: 'Billing history',
        img_path: '/images/community/portal-history.svg',
    },
];

export const BREAD_CRUMBS = [
    {
        id: '1',
        text: 'Billing plans',
    },
    {
        id: '2',
        text: 'Upgrade to Business',
    },
];

export const SOCIAL_WEBINAR_FOOTER_LOGO = [];

export const EVENT_FOOTER_LOGO = [];

export const eventTypes = {
    [SOCIAL_WEBINAR_TAB]: {
        title: 'Social Webinar',
        titleColor: 'lighting.7',
        description:
            'Best for results-driven webinars, webinar series, workshops, cohort-based courses, and town halls that feel like real-life gatherings ',
        logos: [
            {
                title: '',
                image_path: '',
            },
        ],
        comparePlanTitle: 'Compare Plans',
        comparePlanUrl:
            'https://www.airmeet.com/hub/compare-plans-social-webinar/',
        hasInlineComparePlanButton: false,
        paymentType: STANDARD_YEARLY,
        paymentCycle: STANDARD_YEARLY,
        currentFooterLogo: SOCIAL_WEBINAR_FOOTER_LOGO,
    },
    [CONFERENCE_TAB]: {
        title: 'Conference',
        titleColor: 'lighting.1',
        description:
            'Best for visually stunning and ROI-centric virtual and hybrid summits, multi-track events, expos, and fairs',
        logos: [
            {
                title: '',
                image_path: '',
            },
        ],
        comparePlanTitle: 'View Details',
        comparePlanUrl: 'https://www.airmeet.com/hub/conference-plan/',
        hasInlineComparePlanButton: true,
        paymentType: CONFERENCE_STARTER_MONTHLY,
        paymentCycle: CONFERENCE_STARTER_MONTHLY,
        currentFooterLogo: EVENT_FOOTER_LOGO,
    },
    [COMBINED_TAB]: {
        title: 'Social Webinar',
        titleColor: 'lighting.7',
        description:
            'Best for results-driven webinars, webinar series, workshops, cohort-based courses, and town halls that feel like real-life gatherings ',
        logos: [
            {
                title: '',
                image_path: '',
            },
        ],
        comparePlanTitle: 'Compare Plans',
        comparePlanUrl: 'https://www.airmeet.com/hub/compare-pricing-plans/',
        hasInlineComparePlanButton: false,
        paymentType: STANDARD_YEARLY,
        paymentCycle: STANDARD_YEARLY,
        currentFooterLogo: SOCIAL_WEBINAR_FOOTER_LOGO,
    },
};

export const eventTypeAndPlanMapping = {
    // [SOCIAL_WEBINAR_TAB]: [
    //     planMappingToSubTypes[FREE],
    //     planMappingToSubTypes[BUSINESS],
    //     planMappingToSubTypes[ENTERPRISE],
    // ],
    // [CONFERENCE_TAB]: [
    //     // Disabling the Conference Starter plan based on SC-115022
    //     // planMappingToSubTypes[CONFERENCE_STARTER],
    // ],
    [COMBINED_TAB]: [
        planMappingToSubTypes[FREE],
        planMappingToSubTypes[STANDARD],
        planMappingToSubTypes[ENTERPRISE],
    ],
};

export const PRICING_MAIN_FOOTER_LOGO = [
    {
        icon: 'icon-Fedex',
        width: '150px',
        height: '60px',
    },
    {
        icon: 'icon-Volvo',
        width: '150px',
        height: '60px',
    },
    {
        icon: 'icon-Forbes',
        width: '150px',
        height: '60px',
    },
    {
        icon: 'icon-Accenture',
        width: '150px',
        height: '60px',
    },
    {
        icon: 'icon-HP',
        width: '150px',
        height: '60px',
    },
];

export const BILLING_TYPES = [
    { key: 'subscription', title: 'Subscriptions', showBestValue: true },
    { key: 'one-time', title: 'One-Time payment', showBestValue: false },
];

export const BILLING_INFO = {
    [ONE_TIME_30_DAYS_PLAN]: 'For 30 days',
    [ONE_TIME_60_DAYS_PLAN]: 'For 60 days',
    [BUSINESS_MONTHLY]: 'Monthly',
    [BUSINESS_YEARLY]: 'Annually',
    [CONFERENCE_STARTER_MONTHLY]: 'Monthly',
    [STANDARD_YEARLY]: 'Annual subscription',
};
